import React from 'react';

const CO2Icon = ({
  color = '#FFFFFF'
}) => {
  return (
    <svg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M34.375 61.52c1.734 0 3.44.206 5.097.613 4.13-5.302 10.514-8.487 17.34-8.487 3.86 0 7.642 1.024 10.957 2.93 4.7-4.458 10.792-7.11 17.305-7.5-2.183-3.813-6.283-6.388-10.992-6.388-1.093 0-2.148.153-3.16.413-2.18-3.826-6.288-6.412-11.007-6.412-3.504 0-6.676 1.423-8.97 3.723-2.217-.917-4.646-1.43-7.196-1.43-10.4 0-18.833 8.432-18.833 18.833 0 1.93.292 3.79.832 5.542 2.64-1.17 5.555-1.834 8.625-1.834zm52.375-8.5c-7.44 0-14.074 3.444-18.404 8.82-3.122-2.615-7.142-4.194-11.533-4.194-6.752 0-12.627 3.727-15.7 9.23-2.073-.872-4.35-1.355-6.738-1.355C24.78 65.52 17 73.3 17 82.897s7.78 17.375 17.375 17.375H86.75c13.047 0 23.625-10.576 23.625-23.624 0-13.048-10.578-23.625-23.625-23.625zM72.756 38.745c.444-.037.887-.056 1.326-.056 7 0 12.996 4.344 15.46 10.474 3.477.35 6.76 1.355 9.74 2.877.62-1.753.968-3.635.968-5.602 0-9.297-7.537-16.833-16.833-16.833-1.044 0-2.06.108-3.053.29C77.694 25.75 73.047 23 67.75 23c-6.922 0-12.734 4.692-14.47 11.064 2.068-.897 4.314-1.376 6.636-1.376 5 0 9.703 2.266 12.84 6.056z'
        fill={color} fillRule='evenodd'
      />
    </svg>
  );
};

export default CO2Icon;



// WEBPACK FOOTER //
// ./src/app/components/atoms/icons/CO2Icon/CO2Icon.js